module.exports = __webpack_public_path__ + "img/Download.767d5560.svg";